module.exports = __webpack_public_path__ + "static/media/open.e788c5b2.svg";